import { render, staticRenderFns } from "./UniversalPage.vue?vue&type=template&id=2d7e44ed"
import script from "./UniversalPage.vue?vue&type=script&lang=js"
export * from "./UniversalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports